<template>
    <md-modal-dialog class="dialog" v-slot="{ title, message , isHtml }">
      <md-dialog-title>{{ title }}</md-dialog-title>

      <md-dialog-content v-if="isHtml" v-html="message"></md-dialog-content>
      <md-dialog-content v-else>{{ message }}</md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary md-flat" @click="onClose">Close</md-button>
      </md-dialog-actions>

    </md-modal-dialog>
</template>

<script>

import ValidatedInputs from '@/components/ValidatedInput';

export default {
  components: {
    ...ValidatedInputs,
  },
  methods: {
    onClose(){
      this.$modal.submit();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";

  .md-subheader {
    padding: 0px;
  }

  .dialog {
    z-index: 99999 !important;
  }
</style>
